import { useIntl } from "react-intl";

type BookingStepsSectionListItem = {
  bookingStepNumber: number;
  bookingStepTitle: string;
  bookingStepDescription: string;
};

const useBookingStepsSectionList = (): BookingStepsSectionListItem[] => {
  const intl = useIntl();

  return [
    {
      bookingStepNumber: 1,
      bookingStepTitle: intl.formatMessage({
        defaultMessage: "Create your listing",
      }),
      bookingStepDescription: intl.formatMessage({
        defaultMessage:
          "Add photos, set your price and availability, describe your space. Your listing goes live in front of millions of guests.",
      }),
    },
    {
      bookingStepNumber: 2,
      bookingStepTitle: intl.formatMessage({
        defaultMessage: "Welcome guests to your space",
      }),
      bookingStepDescription: intl.formatMessage({
        defaultMessage:
          "You set the rules and choose which bookings to take. Once you confirm, message with guests through your unified inbox.",
      }),
    },
    {
      bookingStepNumber: 3,
      bookingStepTitle: intl.formatMessage({
        defaultMessage: "Get paid every time",
      }),
      bookingStepDescription: intl.formatMessage({
        defaultMessage:
          "Guests pay upfront through Peerspace. Your earnings are deposited directly into your bank account after each booking.",
      }),
    },
  ];
};

export { useBookingStepsSectionList };
